<div class="flex h-full flex-col">
  <div
    class="financials-loader-container flex h-1 grow flex-col gap-8 overflow-y-auto">
    <router-outlet class="hidden"></router-outlet>
  </div>
</div>

<div class="hidden">
  <p-button></p-button>
  <p-selectbutton
    [options]="routes"
    [ngModel]="value()"
    optionLabel="label"
    optionValue="value">
  </p-selectbutton>
  <p-select [options]="[1, 2]" [placeholder]="'Select an option'" />
  <input pInputText />
  <p-datepicker></p-datepicker>
  <textarea rows="5" cols="30" pTextarea></textarea>
  <p-checkbox />
  <p-popover></p-popover>
  <p-table [paginator]="true"></p-table>
  <p-accordion value="0">
    <p-accordion-panel value="0">
      <p-accordion-header>Header I</p-accordion-header>
      <p-accordion-content> </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="1">
      <p-accordion-header>Header II</p-accordion-header>
      <p-accordion-content> </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="2">
      <p-accordion-header>Header III</p-accordion-header>
      <p-accordion-content> </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
  <p-progress-spinner />
  <p-multi-select></p-multi-select>
  <p-tag severity="danger" value="Failed" />
  <p-toast></p-toast>
  <p-meterGroup [value]="[]" />
</div>
